export const CHART_RANGES = [
  ["1m", "近1月"],
  ["3m", "近3月"],
  ["6m", "近6月"],
  ["1y", "近1年"],
  ["all", "全部"],
];

export function isCustomChartRange(chartRange) {
  return Boolean(
    chartRange
    && typeof chartRange === "object"
    && chartRange.kind === "custom"
    && chartRange.startDate
    && chartRange.endDate,
  );
}

export function chartRangeKey(chartRange) {
  return isCustomChartRange(chartRange) ? "custom" : chartRange;
}

export function pointDate(point) {
  return String(point?.date ?? point?.trade_date ?? "");
}

export function filterChartSeries(series, chartRange) {
  if (!Array.isArray(series) || series.length === 0 || chartRange === "all") return series ?? [];
  const lastDate = pointDate(series[series.length - 1]);
  if (!lastDate) return series;
  const { startDate, endDate } = chartRangeBounds(lastDate, chartRange);
  if (!startDate) return series;
  return series.filter((point) => {
    const date = pointDate(point);
    return date >= startDate && (!endDate || date <= endDate);
  });
}

export function filterChartDates(dates, chartRange) {
  if (!Array.isArray(dates) || chartRange === "all" || dates.length === 0) return dates ?? [];
  const { startDate, endDate } = chartRangeBounds(String(dates[dates.length - 1] ?? ""), chartRange);
  if (!startDate) return dates;
  return dates.filter((date) => String(date) >= startDate && (!endDate || String(date) <= endDate));
}

export function chartRangeBounds(lastDate, chartRange) {
  if (isCustomChartRange(chartRange)) {
    return { startDate: chartRange.startDate, endDate: chartRange.endDate };
  }
  const end = new Date(`${lastDate}T00:00:00`);
  if (Number.isNaN(end.getTime())) return {};
  const months = { "1m": 1, "3m": 3, "6m": 6, "1y": 12 }[chartRange];
  if (!months) return {};
  end.setMonth(end.getMonth() - months);
  return { startDate: end.toISOString().slice(0, 10) };
}
